import { CONFIG } from 'constants/config';

export function isChristmasSeason() {
  return CONFIG.SEASONAL.CHRISTMAS_ENABLED;
}

export function isSnowfallEnabled() {
  return CONFIG.SEASONAL.SNOWFALL_ENABLED;
}
